export default __webpack_public_path__ + "static/anuncio-159636a77784c0e89bfb437018a68081.pdf";